import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function TransportWarehouseWrapper({ children }: Props) {
  return (
    <div
      className="relative flex gap-5 size-full p-7.5 rounded-4 overflow-clip"
      style={{
        background:
          "linear-gradient(312deg, rgba(18, 18, 18, 0.00) 75.5%, rgba(54, 141, 68, 0.04) 92%, rgba(47, 192, 71, 0.20) 100%), #121212",
      }}
      data-mz-accent="success"
    >
      {children}
    </div>
  );
}
